(() => {
  const KEY = "ges_favorites_v1";

  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
      return [];
    }
  };

  const write = (arr) => localStorage.setItem(KEY, JSON.stringify(arr));

  const has = (handle) => read().includes(handle);

  const toggle = (handle) => {
  const arr = read();
  const i = arr.indexOf(handle);
  if (i >= 0) arr.splice(i, 1);
  else arr.push(handle);
  write(arr);
  setRootFavState(); // 👈 ICI
  return arr;
};


// ✅ REMOVE = suppression explicite (plus sûr que toggle)
  const remove = (handle) => {
  const arr = read().filter((h) => h !== handle);
  write(arr);
  setRootFavState();
  return arr;
};

  const setBtnState = (btn, active) => {
    btn.classList.toggle("is-fav", active);
    btn.setAttribute("aria-pressed", active ? "true" : "false");
  };
  // ---------- GLOBAL FAVORITES STATE (ANTI-FLASH) ----------
const setRootFavState = () => {
  const hasFavs = read().length > 0;
  document.documentElement.classList.toggle(
    "ges-has-favorites",
    hasFavs
  );
};

// applique l’état immédiatement au chargement du script
setRootFavState();

// ---------- HEADER HEART SYNC (PERSISTENT) ----------
const syncHeaderHeart = () => {
  // 🔒 garantit l’état global avant toute chose
  setRootFavState();

  const headerLink = document.querySelector(
    ".header-actions__action.action__favorites"
  );
  if (!headerLink) return;

  const count = read().length;
  const hasFavs = count > 0;

  headerLink.classList.toggle("has-favorites", hasFavs);
  headerLink.setAttribute(
    "aria-label",
    hasFavs ? `Favorites (${count})` : "Favorites"
  );
};


  // ---------- HEART BUTTONS (collection / cards) ----------
  const initButtons = (root = document) => {
    root.querySelectorAll("[data-fav-btn][data-handle]").forEach((btn) => {
      const handle = btn.dataset.handle;
      setBtnState(btn, has(handle));

      // évite de binder 2x si Shopify re-render
      if (btn.dataset.favBound === "1") return;
      btn.dataset.favBound = "1";

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        toggle(handle);
        setBtnState(btn, has(handle));
        window.dispatchEvent(new CustomEvent("favorites:updated"));
      });
    });
  };

  // ---------- FAVORITES PAGE RENDER ----------
  const elGrid = () => document.getElementById("favorites-grid");
  const elEmpty = () => document.getElementById("favorites-empty");

  const escapeHtml = (s) =>
    String(s || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");

const moneyFromCents = (cents) => {
  const v = Number(cents || 0) / 100;
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: window?.Shopify?.currency?.active || "EUR",
    }).format(v);
  } catch {
    return `${v.toFixed(2)} €`;
  }
};

// Utilise /products/<handle>.js
const fetchProduct = async (handle) => {
  const res = await fetch(`/products/${handle}.js`, {
    credentials: "same-origin",
    headers: { Accept: "application/json" },
  });
  if (!res.ok) throw new Error(`Failed product ${handle}`);
  return res.json();
};

// Card HTML (Favorites page)
const cardHtml = (p) => {
  const title = escapeHtml(p.title);
  const url = `/products/${p.handle}`;
  const img1 = p.images && p.images[0] ? escapeHtml(p.images[0]) : "";
  const img2 = p.images && p.images[1] ? escapeHtml(p.images[1]) : "";
  const price = moneyFromCents(p.price);

  return `
    <div class="favorites-card">
      <a class="favorites-card__media" href="${url}">
  ${img1 ? `<img class="fav-img fav-img--1" src="${img1}" alt="${title}" loading="lazy">` : ""}
  ${img2 ? `<img class="fav-img fav-img--2" src="${img2}" alt="${title}" loading="lazy">` : ""}

  <span class="favorites-hover-arrow" aria-hidden="true">→</span>
</a>


      <div class="favorites-card__info">
        <a class="favorites-card__title" href="${url}">${title}</a>

        <div class="favorites-card__meta">
          <span class="favorites-card__price">${price}</span>

          <div class="favorites-card__actions">
            <a class="favorites-view" href="${url}">View</a>


            <button class="favorites-remove" type="button"
              data-remove-handle="${escapeHtml(p.handle)}">
              Remove
            </button>
          </div>
        </div>
      </div>
    </div>
  `;
};

  const renderFavorites = async () => {
    const grid = elGrid();
    const empty = elEmpty();

    // Si pas sur la page favorites → on ne fait rien
    if (!grid || !empty) return;

    const handles = read();

    if (!handles.length) {
      empty.style.display = "";
      grid.innerHTML = "";
      return;
    }

    empty.style.display = "none";

    try {
      const products = await Promise.all(
        handles.map((h) => fetchProduct(h).catch(() => null))
      );

      const valid = products.filter(Boolean);

      if (!valid.length) {
        empty.style.display = "";
        grid.innerHTML = "";
        return;
      }

      grid.innerHTML = valid.map(cardHtml).join("");

// bouton remove
grid.querySelectorAll("[data-remove-handle]").forEach((btn) => {
  btn.addEventListener("click", (e) => {
    e.preventDefault();
    const handle = btn.getAttribute("data-remove-handle");
    remove(handle);
    window.dispatchEvent(new CustomEvent("favorites:updated"));
  });
});

    } catch (err) {
      console.error("Favorites render error:", err);
      empty.style.display = "";
      grid.innerHTML = "";
    }
  };

  // ------------- INIT -------------
  const init = () => {
  initButtons(document);
  renderFavorites();
  syncHeaderHeart();
};


      // init au chargement
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // si ton thème re-render (facets, etc.)
  document.addEventListener("shopify:section:load", () => {
  initButtons(document);
  syncHeaderHeart();
});

  // refresh favorites page + update hearts
  window.addEventListener("favorites:updated", () => {
    initButtons(document);
    renderFavorites();
    syncHeaderHeart();
  });

  // --- keep header heart state in sync (theme re-renders header) ---
  ["scroll", "resize"].forEach((evt) => {
    window.addEventListener(evt, syncHeaderHeart, { passive: true });
  });

  // --- sync si localStorage change (multi-onglets) ---
  window.addEventListener("storage", (e) => {
    if (e.key === KEY) syncHeaderHeart();
  });

  // ✅ DERNIÈRE LIGNE À AJOUTER (anti-flash back/forward)
  window.addEventListener("pageshow", () => {
    setRootFavState();
    syncHeaderHeart();
  });

})(); // ⬅️ FIN DU FICHIER
